import {usePositions} from 'hooks/Product/DoorDesign';
import React from 'react';
import {GenericFields} from 'components/customer/Product/Specs/GenericFields';

import {Fieldset} from 'components/customer/Product/entity/Fieldset';

type RailPositionType = {
    fieldset: Fieldset;
    fieldName: string;
    selectHandler?: () => void;
    isQFP?: boolean;
};

export const RailPositions = ({
    fieldset,
    fieldName,
    selectHandler,
    isQFP = false,
}: RailPositionType) => {
    const {isLattice, positions} = usePositions(
        fieldName,
        fieldset.name,
        fieldset,
        isQFP,
        selectHandler
    );

    if (positions.length > 0 && !isLattice) {
        return (
            <>
                {isQFP ? <></> : <hr />}
                <GenericFields
                    fields={positions}
                    fieldsetName={fieldset.name}
                    fieldsetTitle={fieldset.title}
                    fieldsetLayout={fieldset.options && fieldset.options.layout}
                    isQFP={isQFP}
                />
            </>
        );
    }

    return <></>;
};
